/** 与安卓 DataChannel 对齐的 JSON 协议（后续实现） */
export type ActionName = "home" | "back" | "recents" | "screen_lock" | "wake";

export type RemoteEvent =
  | { t: "tap"; x: number; y: number }
  | { t: "swipe"; sx: number; sy: number; ex: number; ey: number; durMs: number }
  | { t: "longpress"; x: number; y: number; durMs: number }
  | { t: "action"; name: ActionName }
  | { t: "text"; text: string; mode: "replace" | "insert" };

export type RemoteEventSender = (event: RemoteEvent) => void;

let sender: RemoteEventSender | null = null;

export function setRemoteEventSender(s: RemoteEventSender | null): void {
  sender = s;
}

export function sendRemoteEvent(event: RemoteEvent): void {
  // 当前实现：优先走 sender（Firestore/未来 DataChannel）
  sender?.(event);
}
